import { render, staticRenderFns } from "./renja_rekapitulasi.vue?vue&type=template&id=2c5da225&"
import script from "./renja_rekapitulasi.vue?vue&type=script&lang=js&"
export * from "./renja_rekapitulasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports